import React from 'react';
import { content } from '../data';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <div className="relative">
      <section className="relative min-h-[600px] md:min-h-[70vh] flex items-start pt-40 sm:pt-52 md:pt-64 lg:pt-[18rem] min-[1200px]:pt-[20rem] 2xl:pt-[24rem] pb-12 md:pb-32 overflow-hidden bg-slate-900">
        {/* Background Image */}
        <div className="absolute inset-0 top-0 z-0 overflow-hidden">
          <img 
            src={content.hero.image} 
            alt="Lene Jauert - Lenes Køreskole" 
            className="absolute inset-0 w-full h-full object-cover object-[75%_center] md:object-[100%_center] min-[1200px]:object-top min-[1200px]:scale-110 min-[1200px]:translate-x-8"
          />
          <div className="absolute inset-0 bg-linear-to-r from-slate-900/90 via-slate-900/50 md:via-slate-900/40 to-transparent" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-xl md:max-w-2xl">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-base sm:text-2xl md:text-3xl font-medium text-white/80 uppercase tracking-wide mb-2"
            >
              Med mere end 25 års ekspertise
            </motion.h2>
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="text-3xl sm:text-5xl md:text-6xl font-semibold text-white uppercase tracking-tighter leading-[0.95] mb-6"
            >
              {content.hero.title}
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-lg md:text-2xl font-semibold text-[#04a6df] uppercase mb-4"
            >
              {content.hero.subtitle}
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="text-lg text-white/90 leading-relaxed mb-8 max-w-xl"
            >
              {content.hero.description}
            </motion.p>
          </div>
        </div>

        {/* Decorative vertical line */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-12 bg-white/30 hidden md:block" />
      </section>

      {/* Info Box - Under on mobile, Bottom Right on desktop */}
      <div className="relative md:absolute md:bottom-0 md:right-0 z-20 w-full md:max-w-xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="bg-[#034b89] border-t border-l border-white/20 p-8 md:p-10"
        >
          <div className="flex flex-col md:flex-row md:items-center gap-8 md:gap-12 mb-8">
            <div className="flex-1">
              <h3 className="text-white font-semibold uppercase text-sm tracking-[0.2em] mb-2 opacity-80">Næste holdstart</h3>
              <p className="text-white text-xl font-medium">Tilmeld dig nu for plads</p>
            </div>
            
            {/* Vertical line separator */}
            <div className="hidden md:block w-px h-16 bg-white/20" />
            
            <div className="flex-1">
              <h3 className="text-white font-semibold uppercase text-sm tracking-[0.2em] mb-2 opacity-80">Ekspertise</h3>
              <p className="text-white text-xl font-medium">25 års erfaring</p>
            </div>
          </div>

          <Link 
            to="/tilmeld" 
            className="w-full inline-block text-center bg-[#04a6df] hover:bg-[#0389b9] text-white font-semibold uppercase tracking-widest px-8 py-5 rounded-full transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            Tilmeld dig her
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
